import { createI18n } from "vue-i18n";
import { locales } from "@socotec.io/socio-vue-components";
import appMessages from "@/locales/appMessages";

const messages = {
  en: {
    $vuetify: locales.en.$vuetify,
    ...appMessages.en,
  },
  fr: {
    $vuetify: locales.fr.$vuetify,
    ...appMessages.fr,
  },
};

export default createI18n({
  legacy: false,
  locale: import.meta.env.VITE_APP_I18N_LOCALE || "en",
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: messages,
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false,
});
